export enum ECalendarRange {
  ASAP = "ASAP",
  TODAY = "TODAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  CUSTOM = "CUSTOM",
}
